<script lang="ts">
  /** A user's favorite styles, grouped by parent genre. Read-only chips. */
  interface GenreGroup {
    genre_name: string;
    styles: { key: string; label: string }[];
  }

  let { genres }: { genres: GenreGroup[] } = $props();
</script>

{#if genres.length > 0}
  <section class="fav-genres">
    <h2>Favorite Genres</h2>
    <div class="genre-groups">
      {#each genres as group (group.genre_name)}
        <div class="genre-group">
          <span class="genre-name">{group.genre_name}</span>
          <div class="chips">
            {#each group.styles as style (style.key)}
              <span class="chip">{style.label}</span>
            {/each}
          </div>
        </div>
      {/each}
    </div>
  </section>
{/if}

<style>
  .fav-genres {
    margin-top: 1.5rem;
  }
  h2 {
    font-size: 1.1rem;
    margin: 0 0 0.75rem;
  }
  .genre-groups {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  .genre-group {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
  }
  .genre-name {
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--text-muted);
  }
  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem;
  }
  .chip {
    padding: 0.25rem 0.7rem;
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--cyan);
    background: rgba(0, 229, 255, 0.1);
    border: 1px solid var(--border);
    border-radius: 999px;
  }
</style>
